import { Component, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DeleteGenericService } from 'src/app/services/delete-generic.service';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import {
  enumActions,
  FunctionsService,
  HeaderFilters,
  HttpService,
  IButtonlabelEdit,
  LocalStorageService,
  MenuBreadCrumb,
  MessageService,
  params,
  SessionService,
  TableColumns,
  TableConfiguration,
} from 'brainloper-ui';
import { HistoricalInspections } from 'src/app/models/inspections/historical';
import { HistoricalResponse } from 'src/app/models/inspections/historical-response';
import { GenericResponse } from 'src/app/models/commos/generic-response';
import { ModalFilesComponent } from 'src/app/components/shared/modal-files/modal-files.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'app-inspection-history',
    templateUrl: './inspection-history.component.html',
    styleUrls: ['./inspection-history.component.scss'],
    standalone: false
})
export class InspectionHistoryComponent implements OnInit {
  public urlGetTablaHistoricoPreo: string = `${EndpointDictionary.HistoryPreop.HISTORY_PREOP_TABLE}`;
  private urlGetDetalleHistoricoPreo: string = `${EndpointDictionary.PreopRHistory.CRUD_PREOP_R_HISTORY_DATA}`;
  private urlDeletePreo: string = `${EndpointDictionary.HistoryPreop.CRUD_HISTORY_PREOP_DATA}`;

  public paramsPreoperacional: params[] = [{ id: 'equipmentId', value: '0' }];
  public bodyPre: HistoricalInspections = new HistoricalInspections();
  public selected = new UntypedFormControl(0);
  public xslxParams: params[] = [
    { id: 'includeQuestions', value: true },
    { id: 'baseUrl', value: `${EndpointDictionary.Base._BASE_URL_V2}` },
  ];

  public labels: Array<IButtonlabelEdit> = [];
  public roleId:number
  public companyId:number

  //tabla Preoperacionales
  public recargarTablaPreo = new EventEmitter<any>();
  public configurationPreo: TableConfiguration = {
    edit: false,
    add: true,
    delete: true,
    selectable: false,
    addPer: true,
    primaryKey: 'id',
    view: true,
    exportXslxWithPages: true,
  };
  public columnasPreo: TableColumns<HistoricalInspections>[] = [
    {
      ID: 'code',
      label: 'Código equipo',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'equipmentBrand',
      label: 'Marca',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'startDate',
      label: 'Fecha Inicio',
      type: 'dateWithTime',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'finalDate',
      label: 'Fecha Fin',
      type: 'dateWithTime',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'userName',
      label: 'Diligenció',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'versionInspection',
      label: 'Versión formato',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'inspectionCode',
      label: 'Código formato',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'formName',
      label: 'Formulario',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
    {
      ID: 'periodicityValue',
      label: 'Periodicidad',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
  ];

  headerFilters: Array<HeaderFilters> = [
    {
      tN: 'equipos',
      labelFilter: 'Equipo',
      urlData: EndpointDictionary.Equipment.EQUIPMENT_COMBO,
      visibleField: 'code',
      primaryKey: 'id',
      type: 'select',
      value: '',
      active: true,
    },
    {
      tN: 'usuarios',
      labelFilter: 'Diligenció',
      urlData: EndpointDictionary.User.USER_COMBO,
      visibleField: 'name',
      primaryKey: 'userId',
      type: 'select',
      value: '',
    },
    {
      tN: 'formulario_inspeccion',
      labelFilter: 'Código Formato',
      visibleField: 'inspectionCode',
      fileNameDb: 'codigo',
      urlData: EndpointDictionary.InspectionForm.COMBO_CODE,
      type: 'select',
      value: '',
    },
    {
      tN: 'formulario_inspeccion',
      labelFilter: 'Versión Formato',
      visibleField: 'versionInspection',
      fileNameDb: 'version',
      urlData: EndpointDictionary.InspectionForm.COMBO_VERSION,
      type: 'select',
      value: '',
    },
    {
      tN: 'formulario_inspeccion',
      labelFilter: 'Formulario',
      visibleField: 'name',
      fileNameDb: 'nombre',
      urlData: EndpointDictionary.InspectionForm.INSPECTION_FORM_COMBO,
      type: 'select',
      value: '',
    },
    {
      tN: 'historicos_preop',
      labelFilter: 'Fecha inicio igual a',
      visibleField: 'fecha_inicio',
      type: 'date',
      value: '',
    },
    {
      tN: 'historicos_preop',
      labelFilter: 'Fecha inicio entre',
      visibleField: 'fecha_inicio',
      type: 'dateRange',
      value: '',
    },
    {
      tN: 'historicos_preop',
      labelFilter: 'Fecha fin igual a',
      visibleField: 'fecha_fin',
      type: 'date',
      value: '',
    },
    {
      tN: 'historicos_preop',
      labelFilter: 'Fecha fin entre',
      visibleField: 'fecha_fin',
      type: 'dateRange',
      value: '',
    },
  ];

  //tabla detalle preoperacional
  public title: string = 'Inspección';
  public recargarTablaPreoDetalle = new EventEmitter<any>();
  public dataPreoDetalle;
  public configurationPreoDetalle: TableConfiguration = {
    primaryKey: 'id',
    exportXslx: true,
    hideTitle: true,
  };
  public columnasPreoDetalle: TableColumns<HistoricalResponse>[] = [
    {
      ID: 'question',
      label: 'Pregunta',
      type: 'text',
      style: {
        textAlign: 'left',
      },
    },
    {
      ID: 'response',
      label: 'Respuesta',
      type: 'text',
      style: {
        textAlign: 'center',
      },
      rules: [
        {
         
          action: enumActions.SHOW_FILE_ICON,
        },
      ],
    },
  ];

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: 'Inicio',
      router: '/inicio',
    },
    {
      name: 'Inspecciones',
      current: true,
    },
  ];

  headerFileXlsm: Array<params> = [
    { id: 'question', value: 'Pregunta' },
    { id: 'response', value: 'Respuesta' },
    { id: 'responseType', value: 'Tipo respuesta' },
  ];

  headerFileTableXlsm: Array<params> = [
    { id: 'question', value: 'pregunta' },
    { id: 'response', value: 'respuesta' },
    { id: 'responseType', value: 'tipo respuesta' },
    { id: null, value: 'Equipo : {code}' },
    { id: null, value: 'Realizado por : {userName}' },
    { id: null, value: 'Fecha inicio : {formattedStartDate}' },
    { id: null, value: 'Codigo formato inspeccion : {inspectionCode}' },
    { id: null, value: 'Version formato inspeccion : {versionInspection}' },
    { id: null, value: 'Fecha formato : {formattedDateInspectionFormat}' },
    { id: null, value: 'Formulario : {formName}' },
    { id: null, value: 'Periodicidad : {periodicityValue}' },
  ];

  constructor(
    private message: MessageService,
    private http: HttpService,
    private router: Router,
    private deleteItem: DeleteGenericService,
    private session: SessionService,
    private activeRoute: ActivatedRoute,
    private functionEter: FunctionsService,
    private storage: LocalStorageService,
    private dialog: MatDialog
  ) {
      this.roleId = this.storage.get<number>('roleId');
      this.companyId = this.storage.get<number>('companyId');
  }

  ngOnInit(): void {
    this.activeRoute.queryParams.subscribe(async (params) => {
      if (params['filterToday']) {
        let today = this.functionEter.dateDB(new Date());
        this.headerFilters[7].active = true;
        this.headerFilters[7].value = `${today}`;
      }
    });
  }

  async viewDetail($event: HistoricalInspections[]) {
    this.bodyPre = $event[0];
    this.labels = [
      {
        label: 'Código equipo:',
        value: this.bodyPre.code,
        edit: false,
      },
      {
        label: 'Diligenció:',
        value: this.bodyPre.userName,
        edit: false,
      },
      {
        label: 'Código formato:',
        value: this.bodyPre.inspectionCode,
        edit: false,
      },
      {
        label: 'Versión formato:',
        value: this.bodyPre.versionInspection,
        edit: false,
      },
      {
        label: 'Fecha inspección:',
        value: this.bodyPre.startDate,
        edit: false,
      },
      {
        label: 'Formulario:',
        value: this.bodyPre.formName,
        edit: false,
      },
      {
        label: 'Periodicidad:',
        value: `${this.bodyPre.periodicityValue}`,
        edit: false,
      },
    ];

    try {
      let res: GenericResponse = await this.http.getDataBody(
        `${this.urlGetDetalleHistoricoPreo}/${$event[0].id}`
      );
      if (res) {
        this.dataPreoDetalle = res[0].questions;

        if (this.dataPreoDetalle && Array.isArray(this.dataPreoDetalle)) {
          this.dataPreoDetalle.forEach((question) => {
            if (question.responseType === 'Imagen' && question.response) {
              question.response = `${EndpointDictionary.Base._BASE_URL_V2}${question.response}/${this.companyId}`;
            }
          });
        }

        this.headerFileXlsm[3] = {
          id: null,
          value: `Código equipo: ${this.bodyPre.code}`,
        };
        this.headerFileXlsm[4] = {
          id: null,
          value: `Marca del equipo: ${this.bodyPre.equipmentBrand}`,
        };
        this.headerFileXlsm[5] = {
          id: null,
          value: `Diligenció: ${this.bodyPre.userName}`,
        };
        this.headerFileXlsm[6] = {
          id: null,
          value: `Fecha inspección: ${this.bodyPre.startDate}`,
        };
        this.headerFileXlsm[7] = {
          id: null,
          value: `Código formato: ${this.bodyPre.inspectionCode}`,
        };
        this.headerFileXlsm[8] = {
          id: null,
          value: `Versión formato: ${this.bodyPre.versionInspection}`,
        };
        this.headerFileXlsm[9] = {
          id: null,
          value: `Fecha del formato: ${this.bodyPre.formattedDateInspectionFormat}`,
        };
        this.headerFileXlsm[10] = {
          id: null,
          value: `Nombre del formulario ${this.bodyPre.formName}`,
        };
        this.headerFileXlsm[11] = {
          id: null,
          value: `Periodicidad: ${this.bodyPre.periodicityValue}`,
        };
        this.selected.setValue(1);
      }
    } catch (error) {
      this.message.Error('Error', error);
    }
  }

  async eliminarPreo($event) {
    let res = await this.deleteItem.deleteD(
      $event,
      this.urlDeletePreo,
      'id',
      'Preoperacional',
      'Preoperacionales'
    );
    this.recargarTablaPreo.emit();
  }

  addPre($event) {
    this.session.setData('showDate', true);
    this.router.navigate(['/mantenimiento/preoperacionales/diligenciar']);
  }

  back($event) {
    switch ($event.index) {
      case 0:
        this.selected.setValue(0);
        break;
      case 1:
        this.selected.setValue(1);
        break;
      default:
        break;
    }
  }

  onFileIconClick($event: string) {
    this.dialog.open(ModalFilesComponent, {
      data: $event
    });
  }
}
